import { createContext, useContext, useEffect, useRef } from "react";

// Lets pages tell the pull-to-refresh in Main that a refresh (which remounts the page)
// would lose work - an open editor, a dirty form, uploads still running
export const RefreshGuardContext = createContext({ register: () => () => {} });

// `hasUnsavedWork` is called when a refresh is requested, so it always sees the latest state
export const useRefreshGuard = (hasUnsavedWork) => {
  const { register } = useContext(RefreshGuardContext);
  const checkRef = useRef(hasUnsavedWork);
  checkRef.current = hasUnsavedWork;

  useEffect(() => register(() => checkRef.current()), [register]);
};
